// 積分相關翻譯

export const credits = {
    availableCredits: 'Available Credits',
    creditsUsed: 'Credits Used',
    totalCredits: 'Total Credits',
    buyCredits: 'Buy Credits',
    freeCredits: 'Free Credits',
    paidCredits: 'Paid Credits',
    credits: 'Credits',
    remainingCredits: 'Remaining Credits',
    recharge: 'Recharge',
    transactionHistory: 'Transaction History',
    transactionNo: 'Transaction No.',
    amount: 'Amount',
    transactionTime: 'Transaction Time',
    noTransactionRecords: 'No transaction records',
    transactionType: {
      title: 'Transaction Type',
      earned: 'Earned',
      spent: 'Spent',
      refunded: 'Refunded',
      catooGenerate: 'Catoo Generate',
      newUserReward: 'New User Reward'
    }
  };
